export default "__VITE_ASSET__09vRATot__"